/**
 * ScoreboardPage - Standalone page for the scoreboard
 *
 * This page is designed to be opened in a new window/tab so users
 * can view the scoreboard alongside the main application.
 */

import * as React from 'react';
import { Scoreboard } from '../../sections/scoreboard/Scoreboard';

/**
 * Standalone scoreboard page that can be opened in a new window.
 * The close button will close the browser tab/window.
 */
export const ScoreboardPage = (): React.ReactElement => {
  const handleClose = (): void => {
    window.close();
  };

  return <Scoreboard onClose={handleClose} />;
};

export default ScoreboardPage;
